import { render, staticRenderFns } from "./Consierge.vue?vue&type=template&id=768e86d2"
import script from "./Consierge.vue?vue&type=script&lang=js"
export * from "./Consierge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports